import {useState, useRef, useCallback, type PropsWithChildren} from 'react'
import {ArrowRightIcon} from '@primer/octicons-react'
import {ActionList, Dialog} from '@primer/react'
import styles from './RelationshipsViewAllButton.module.css'
import {LABELS} from '../../../constants/labels'

export type RelationshipsViewAllButtonProps = PropsWithChildren<{
  dialogTitle: string
}>

export function RelationshipsViewAllButton({dialogTitle}: RelationshipsViewAllButtonProps) {
  const [isDialogOpen, setIsDialogOpen] = useState(false)
  const linkItemRef = useRef<HTMLLIElement>(null)
  const onDialogClose = useCallback(() => setIsDialogOpen(false), [])

  return (
    <>
      <ActionList.Item onSelect={() => setIsDialogOpen(!isDialogOpen)} ref={linkItemRef} role="button">
        <ActionList.LeadingVisual>
          <div className={styles.RelationshipsViewAllButton_LeadingSpacer} />
        </ActionList.LeadingVisual>

        <span className={styles.RelationshipsViewAllButton_Label}>
          {LABELS.relationViewAll} <ArrowRightIcon />
        </span>
      </ActionList.Item>

      {isDialogOpen && <Dialog title={dialogTitle} onClose={onDialogClose} returnFocusRef={linkItemRef} />}
    </>
  )
}

try{ RelationshipsViewAllButton.displayName ||= 'RelationshipsViewAllButton' } catch {}